import { Alert, List } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const ErrorList: React.FC<ErrorListProps> = ({ errors }) => {
  return (
    <div className="twinge-error-list">
      <List
        dataSource={errors}
        split={false}
        renderItem={(error, index) => (
          <List.Item key={index}>
            <div className="twinge-error-container">
              <div className="twinge-error-icon">
                <ExclamationCircleOutlined />
              </div>
              <p className="twinge-error-message">{error}</p>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};
export default ErrorList;
